import { Divider, SimpleGrid } from '@mantine/core';
import { useContainerQuery } from 'src/UI/app-container/ContainerBreakpoint';
import { ProfileFormField } from 'src/non-financial-data/components/ProfileFormField';
import { ProfileFormList } from 'src/non-financial-data/components/ProfileFormList';

const occupationDefaultFields = {
  employer_name: '',
  employment_start_date: '',
  employment_end_date: '',
  is_member_of_workplace_pension: '',
};

export function EmploymentFields() {
  const cq = useContainerQuery();

  return (
    <>
      <SimpleGrid cols={cq({ base: 1, sm: 2 })}>
        <ProfileFormField
          entityType="EmploymentInfo"
          fieldName="employment_status"
          label="Employment status"
        />
        <ProfileFormField entityType="EmploymentInfo" fieldName="occupation" label="Occupation" />
      </SimpleGrid>

      <Divider />

      <ProfileFormList
        entityType="Occupation"
        addButtonLabel="Add employer"
        defaultFields={occupationDefaultFields}
      >
        {index => (
          <SimpleGrid cols={cq({ base: 1, sm: 2, md: 4 })}>
            <ProfileFormField
              entityType="Occupation"
              fieldName="employer_name"
              label="Employer name"
              index={index}
            />
            <ProfileFormField
              entityType="Occupation"
              fieldName="employment_start_date"
              label="Start date"
              index={index}
            />
            <ProfileFormField
              entityType="Occupation"
              fieldName="employment_end_date"
              label="End date"
              index={index}
            />
            <ProfileFormField
              entityType="Occupation"
              fieldName="is_member_of_workplace_pension"
              label="Member of workplace pension"
              index={index}
            />
          </SimpleGrid>
        )}
      </ProfileFormList>
    </>
  );
}
